import React from 'react';

import { createClassName } from 'utils/createClassName';

import './modalPressControlStyles.scss';

type SharedProps = {
  theme: 'primary' | 'secondary';
  disabled?: boolean;
};

type SubmitProps = SharedProps & {
  type: 'submit';
};

type ButtonProps = SharedProps & {
  type: 'button';
  onPress(): void;
};

type Props = SubmitProps | ButtonProps;

export const ModalPressControlComponent: React.FC<Props> = (props) => {
  const { children, type, theme, disabled } = props;

  const createModalPressControlClassName = createClassName('modalPressControl');

  const buttonClassName = createModalPressControlClassName('button', { theme });

  const handleClick = React.useCallback(() => {
    if (props.type === 'button') {
      props.onPress();
    }
  }, [props]);

  return (
    <button
      type={type}
      disabled={disabled}
      className={buttonClassName}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};
